/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIButton from 'UIComponents/button/UIButton';
import UITruncateString from 'UIComponents/text/UITruncateString';
import styled from 'styled-components';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UILink from 'UIComponents/link/UILink';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { PublishTypes } from '../constants/PublishTypes';
import UIIcon from 'UIComponents/icon/UIIcon';
import { useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Bold = ({
  children
}) => {
  return /*#__PURE__*/_jsx("b", {
    children: children
  });
};
const PublishScheduledAlertMessage = ({
  canScheduleWithContentCrmObject
}) => {
  return /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: canScheduleWithContentCrmObject ? 'components.publishSuccessAlert.scheduledMessageNew_jsx' : 'components.publishSuccessAlert.scheduledMessage_jsx',
    options: {
      uiIconProps: {
        name: 'time',
        size: 16
      }
    },
    elements: {
      Bold,
      UIIcon
    }
  });
};
const CancelScheduledUnpublishMessage = () => /*#__PURE__*/_jsx(FormattedMessage, {
  message: "components.publishSuccessAlert.cancelScheduledUnpublishMessage"
});
const UITruncateStringInlineFlex = styled(UITruncateString).withConfig({
  displayName: "displayPublishSuccessAlert__UITruncateStringInlineFlex",
  componentId: "sc-1tgn64b-0"
})(["display:inline-flex !important;"]);
const PublishSuccessAlertMessage = ({
  publishedContentUrl
}) => {
  const [urlCopied, setUrlCopied] = useState(false);
  const resetUrlCopiedStatus = () => setUrlCopied(false);
  const handleCopyUrl = () => {
    // eslint-disable-next-line compat/compat
    navigator.clipboard.writeText(publishedContentUrl);
    setUrlCopied(true);
    setTimeout(resetUrlCopiedStatus, 2000);
  };
  return /*#__PURE__*/_jsxs(UIFlex, {
    align: "center",
    justify: "between",
    wrap: "nowrap",
    children: [/*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "components.publishSuccessAlert.message_jsx",
      options: {
        linkProps: {
          href: publishedContentUrl,
          external: true
        },
        truncateStringProps: {
          maxWidth: window.innerWidth * 0.4
        }
      },
      elements: {
        UILink,
        UITruncateStringInlineFlex
      }
    }), /*#__PURE__*/_jsx(UIButton, {
      size: "xs",
      className: "m-left-5",
      use: "tertiary-light",
      onClick: handleCopyUrl,
      style: {
        minWidth: '80px'
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `components.publishSuccessAlert.copyUrlAction.${urlCopied ? 'urlCopied' : 'copyUrl'}`
      })
    })]
  });
};
const PublishSuccessAlertTitle = ({
  contentType,
  publishType
}) => {
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: `components.publishSuccessAlert.title.${contentType}.${publishType}`
  });
};
export const displayPublishSuccessAlert = ({
  contentType,
  publishType,
  publishedContentUrl,
  canScheduleWithContentCrmObject = false
}) => {
  FloatingAlertStore.addAlert({
    titleText: /*#__PURE__*/_jsx(PublishSuccessAlertTitle, {
      contentType: contentType,
      publishType: publishType
    }),
    message: publishType === PublishTypes.schedule ? /*#__PURE__*/_jsx(PublishScheduledAlertMessage, {
      canScheduleWithContentCrmObject: canScheduleWithContentCrmObject
    }) : publishType === PublishTypes.cancelScheduledUnpublish ? /*#__PURE__*/_jsx(CancelScheduledUnpublishMessage, {}) : /*#__PURE__*/_jsx(PublishSuccessAlertMessage, {
      publishedContentUrl: publishedContentUrl
    }),
    style: {
      maxWidth: '90%'
    },
    type: 'success',
    timeout: 8000
  });
};